document.addEventListener('DOMContentLoaded', () => {
  const root = window.Shopify?.routes?.root || '/';
  const endpoint = (path) => root + path;
  const toast = document.querySelector('[data-cart-toast]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const drawerBody = document.querySelector('[data-cart-drawer-body]');
  const escapeHtml = (value) => String(value || '').replace(/[&<>"']/g, (char) => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:window.Shopify?.currency?.active || 'EUR'}).format(Number(cents || 0) / 100);
  const activeCurrency = window.Shopify?.currency?.active || 'EUR';
  const eligibleHandles = new Set(['goy-brain-tee','born-2-be-a-goy-tee','free-your-mind-tee','my-government-promised-me-more-tee','born-2-be-a-goy-oversized-tee','goy-brain-long-sleeve','goy-brain-pullover-hoodie','goy-pullover-hoodie-color-edition','my-government-promised-me-more-hoodie','goy-crewneck-sweatshirt']);
  const flagshipHandles = new Set(['goy-brain-tee','born-2-be-a-goy-tee','free-your-mind-tee','my-government-promised-me-more-tee']);

  const cartProgressMarkup = (cart) => {
    const paidCount = cart.items.reduce((count, item) => {
      const role = item.properties?.['_Bundle Role'] || '';
      return count + (eligibleHandles.has(item.handle) && role !== 'FREE TEE' ? item.quantity : 0);
    }, 0);
    const freeCount = cart.items.reduce((count, item) => count + (item.properties?.['_Bundle Role'] === 'FREE TEE' ? item.quantity : 0), 0);
    const shipping = activeCurrency === 'EUR'
      ? (cart.total_price >= 6000 ? 'FREE SHIPPING UNLOCKED' : `${money(6000 - cart.total_price)} away from FREE SHIPPING`)
      : 'FREE SHIPPING CALCULATED AT CHECKOUT';
    let bundle = '';
    if (paidCount >= 3 && freeCount === 0) bundle = 'FREE TEE UNLOCKED — CHOOSE YOURS';
    else if (paidCount === 2) bundle = 'ADD 1 MORE ITEM TO UNLOCK A FREE TEE';
    return `<div class="cart-progress"><p>${escapeHtml(shipping)}</p>${bundle ? `<p>${escapeHtml(bundle)}</p>` : ''}</div>`;
  };

  const getCart = async () => {
    const response = await fetch(endpoint('cart.js'), {headers:{Accept:'application/json'}});
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  };

  const updateCart = async () => {
    const cart = await getCart();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    if (drawerBody) {
      if (!cart.items.length) {
        drawerBody.innerHTML = '<p>Your bag is empty.</p>';
      } else {
        drawerBody.innerHTML = cartProgressMarkup(cart) + cart.items.map((item) => '<article class="drawer-item"><img src="' + escapeHtml(item.image || '') + '" alt=""><div><b>' + escapeHtml(item.product_title) + '</b><small>' + escapeHtml(item.variant_title || '') + '</small><small>' + money(item.final_line_price) + '</small></div><button type="button" data-drawer-remove="' + escapeHtml(item.key) + '">Remove</button></article>').join('');
      }
    }
    return cart;
  };

  const openDrawer = async () => {
    if (!drawer) return;
    if (!drawer.open) drawer.showModal();
    try { await updateCart(); } catch (_) {}
  };

  document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', openDrawer));
  document.querySelector('[data-cart-close]')?.addEventListener('click', () => drawer?.close());
  drawer?.addEventListener('click', (event) => { if (event.target === drawer) drawer.close(); });
  drawerBody?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-drawer-remove]');
    if (!button) return;
    button.disabled = true;
    await fetch(endpoint('cart/change.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:button.dataset.drawerRemove,quantity:0})});
    await updateCart();
  });

  const showToast = () => {
    if (!toast) return;
    toast.hidden = false;
    window.clearTimeout(window.acquarelloToast);
    window.acquarelloToast = window.setTimeout(() => { toast.hidden = true; }, 2800);
  };

  const addItems = async (items) => {
    const response = await fetch(endpoint('cart/add.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
    if (!response.ok) throw new Error('Could not add');
    await updateCart();
  };

  document.querySelectorAll('[data-quick-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const id = form.querySelector('[name=id]')?.value;
      if (!id || button?.disabled) return;
      button.disabled = true;
      try { await addItems([{id,quantity:1}]); showToast(); }
      catch (_) { window.alert('Could not add this item. Please try again.'); }
      finally { button.disabled = false; }
    });
  });

  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((button) => button.addEventListener('click', () => {
      if (main && button.dataset.src) { main.src = button.dataset.src; main.removeAttribute('srcset'); main.alt = button.dataset.alt || ''; }
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((item) => item.setAttribute('aria-current','false'));
      button.setAttribute('aria-current','true');
    }));
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const variantInput = form.querySelector('[data-variant-id]');
    const addButton = form.querySelector('[data-add-product]');
    const buyButton = form.querySelector('[data-buy-now]');
    const dataNode = form.querySelector('[data-product-variants]');
    const price = form.closest('.product-details')?.querySelector('[data-live-price]');
    const mainImage = form.closest('.product-shell')?.querySelector('[data-gallery-main]');
    const quantityInput = form.querySelector('[data-offer-quantity]');
    const offerStack = form.querySelector('[data-offer-stack]');
    const bundleModal = form.querySelector('[data-bundle-modal]');
    const bundleClose = form.querySelector('[data-bundle-close]');
    let selectedOfferCode = '';
    let variants = [];
    let activeBundleButton = null;
    let currentVariant = null;
    try { variants = JSON.parse(dataNode?.textContent || '[]'); } catch (_) {}

    const optionGroups = Array.from(form.querySelectorAll('[data-option-index]'));
    const selected = () => optionGroups.map((group) => group.querySelector('input:checked')?.value || '');
    const closeMenus = (except) => optionGroups.forEach((group) => {
      const menu = group.querySelector('[data-option-menu]');
      const trigger = group.querySelector('[data-option-trigger]');
      if (group !== except && menu) { menu.hidden = true; trigger?.setAttribute('aria-expanded', 'false'); }
    });
    const updateOptionTrigger = (group, value) => {
      const trigger = group.querySelector('[data-option-trigger]');
      const label = group.querySelector('[data-trigger-label]');
      const swatch = group.querySelector('[data-trigger-swatch]');
      if (label) label.textContent = value;
      if (swatch) swatch.style.setProperty('--swatch', String(value).toLowerCase().replace(/\s+/g, '-'));
      group.querySelectorAll('[data-option-value]').forEach((button) => button.setAttribute('aria-pressed', button.dataset.optionValue === value ? 'true' : 'false'));
      trigger?.setAttribute('aria-label', `${group.dataset.optionName}: ${value}`);
    };
    optionGroups.forEach((group) => {
      const trigger = group.querySelector('[data-option-trigger]');
      const menu = group.querySelector('[data-option-menu]');
      trigger?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); const open = menu?.hidden; closeMenus(group); if (menu) menu.hidden = !open; trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      group.querySelectorAll('[data-option-value]').forEach((button) => button.addEventListener('click', (event) => {
        event.preventDefault();
        const input = group.querySelector(`input[value="${CSS.escape(button.dataset.optionValue)}"]`);
        if (input) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles:true})); }
        updateOptionTrigger(group, button.dataset.optionValue);
        if (menu) menu.hidden = true;
        trigger?.setAttribute('aria-expanded', 'false');
      }));
      updateOptionTrigger(group, group.querySelector('input:checked')?.value || group.querySelector('[data-option-value]')?.dataset.optionValue || '');
    });
    document.addEventListener('click', (event) => { if (!event.target.closest('[data-variant-dropdown]')) closeMenus(); }, {passive:true});

    const refreshOfferTotals = (variant) => {
      if (!variant) return;
      offerStack?.querySelectorAll('[data-offer]').forEach((offer) => {
        const kind = offer.dataset.offerKind || 'standard';
        const regularCount = Number(offer.dataset.offerRegularCount || 1);
        const selectedLines = Array.from(offer.querySelectorAll('[data-bundle-plus].is-filled'));
        const selectedPrices = selectedLines.map((line) => Number(line.dataset.priceCents || variant.priceCents || 0));
        const linePrices = [Number(variant.priceCents || 0), ...selectedPrices];
        while (linePrices.length < regularCount) linePrices.push(Number(variant.priceCents || 0));
        const regularCents = linePrices.slice(0, regularCount).reduce((sum, itemPrice) => sum + itemPrice, 0);
        let savingCents = 0;
        if (kind === 'fixed') savingCents = Math.min(Number(offer.dataset.offerFixedCents || 0), regularCents);
        if (kind === 'buy3get1') {
          const freeLine = selectedLines.find((line) => line.dataset.bundleRole === 'free');
          const freePrice = Number(freeLine?.dataset.priceCents || variant.priceCents || 0);
          savingCents = Math.min(Number(offer.dataset.offerFreeCapCents || 3500), freePrice);
        }
        const saleCents = Math.max(0, regularCents - savingCents);
        const total = offer.querySelector('[data-offer-total]');
        const saving = offer.querySelector('[data-offer-saving]');
        if (total) total.innerHTML = savingCents ? `${money(saleCents)} <del>${money(regularCents)}</del>` : money(saleCents);
        if (saving) saving.textContent = savingCents ? `You save ${money(savingCents)}` : 'Standard price';
      });
    };

    const sync = () => {
      const options = selected();
      const variant = variants.find((item) => item.options && item.options.length === options.length && item.options.every((option,index) => String(option).trim() === String(options[index]).trim()));
      if (!variant) { if (addButton) addButton.disabled = true; if (buyButton) buyButton.disabled = true; return; }
      currentVariant = variant;
      variantInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (mainImage && variant.image) { mainImage.src = variant.image; mainImage.removeAttribute('srcset'); }
      const gallery = form.closest('.product-shell')?.querySelector('[data-gallery]');
      gallery?.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.setAttribute('aria-current', String(thumb.dataset.mediaId) === String(variant.mediaId) ? 'true' : 'false'));
      form.querySelectorAll('[data-bundle-line="1"]').forEach((line) => {
        const thumb = line.querySelector('[data-bundle-thumb] img');
        const lineVariant = line.querySelector('[data-bundle-line-variant]');
        if (thumb && variant.image) {
          thumb.src = variant.image;
          thumb.removeAttribute('srcset');
        }
        if (lineVariant) lineVariant.textContent = variant.title || '';
      });
      refreshOfferTotals(variant);
      if (addButton) addButton.disabled = !variant.available;
      if (buyButton) buyButton.disabled = !variant.available;
      form.querySelectorAll('[data-current-option]').forEach((select) => {
        const value = options[Number(select.dataset.currentOption)];
        if (value && select.value !== value) select.value = value;
        const swatch = select.parentElement?.querySelector('[data-current-swatch]');
        if (swatch && value) swatch.style.setProperty('--swatch', String(value).toLowerCase().replace(/\s+/g, '-'));
      });
      form.querySelectorAll('[data-bundle-line="1"] [data-bundle-variant]').forEach((node) => { node.value = variant.id; });
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({},'',url);
    };

    const modalCloseMenus = (except) => bundleModal?.querySelectorAll('[data-modal-option-dropdown]').forEach((group) => {
      const menu = group.querySelector('[data-modal-option-menu]');
      const trigger = group.querySelector('[data-modal-option-trigger]');
      if (group !== except && menu) { menu.hidden = true; trigger?.setAttribute('aria-expanded', 'false'); }
    });
    const modalVariants = (card) => {
      try { return JSON.parse(card?.querySelector('[data-modal-variants]')?.textContent || '[]'); } catch (_) { return []; }
    };
    const updateModalOptionTrigger = (group, value) => {
      const label = group.querySelector('[data-modal-trigger-label]');
      const swatch = group.querySelector('[data-modal-trigger-swatch]');
      if (label) label.textContent = value;
      if (swatch) swatch.style.setProperty('--swatch', String(value).toLowerCase().replace(/\s+/g, '-'));
      group.querySelectorAll('[data-modal-option-value]').forEach((item) => item.setAttribute('aria-pressed', item.dataset.modalOptionValue === value ? 'true' : 'false'));
      group.dataset.modalSelectedValue = value;
    };
    const applyModalVariant = (card, variant) => {
      if (!card || !variant) return;
      const groups = Array.from(card.querySelectorAll('[data-modal-option-dropdown]'));
      groups.forEach((group, index) => { if (variant.options?.[index] != null) updateModalOptionTrigger(group, variant.options[index]); });
      card.dataset.modalSelectedVariant = variant.id;
      const image = card.querySelector('[data-modal-image]');
      const imageWrap = card.querySelector('.bundle-modal__image');
      const priceNode = card.querySelector('[data-modal-price]');
      const choose = card.querySelector('[data-modal-choose]');
      if (image && variant.image) { image.src = variant.image; image.removeAttribute('srcset'); }
      else if (variant.image && imageWrap) { imageWrap.innerHTML = `<img src="${escapeHtml(variant.image)}" alt="" data-modal-image>`; }
      if (priceNode && variant.price) priceNode.textContent = variant.price;
      if (choose) choose.disabled = !variant.available;
    };
    const modalVariant = (card) => {
      const groups = Array.from(card?.querySelectorAll('[data-modal-option-dropdown]') || []);
      const values = groups.map((group) => group.dataset.modalSelectedValue || group.querySelector('[data-modal-option-value][aria-pressed=true]')?.dataset.modalOptionValue || group.querySelector('[data-modal-option-value]')?.dataset.modalOptionValue || '');
      const variantsForCard = modalVariants(card);
      let variant = variantsForCard.find((item) => item.options?.length === values.length && item.options.every((value, index) => String(value) === String(values[index])));
      if (!variant && values.length) variant = variantsForCard.find((item) => item.options?.some((value, index) => String(value) === String(values[index])));
      return variant || variantsForCard[0];
    };
    const setModalOption = (card, group, value) => {
      const index = Number(group.dataset.modalOptionIndex || 0);
      const groups = Array.from(card.querySelectorAll('[data-modal-option-dropdown]'));
      const values = groups.map((item) => item.dataset.modalSelectedValue || item.querySelector('[data-modal-option-value][aria-pressed=true]')?.dataset.modalOptionValue || item.querySelector('[data-modal-option-value]')?.dataset.modalOptionValue || '');
      values[index] = value;
      const variantsForCard = modalVariants(card);
      let variant = variantsForCard.find((item) => item.options?.length === values.length && item.options.every((itemValue, itemIndex) => String(itemValue) === String(values[itemIndex])));
      if (!variant) variant = variantsForCard.find((item) => String(item.options?.[index]) === String(value));
      applyModalVariant(card, variant);
    };
    const renderBundleSelection = (button, card, variant) => {
      const image = variant?.image || card?.querySelector('[data-modal-image]')?.src || '';
      const title = card?.querySelector('h3')?.textContent || '';
      const variantTitle = variant?.title || '';
      button.dataset.variantId = variant?.id || '';
      button.dataset.priceCents = variant?.priceCents || '0';
      button.dataset.productHandle = card?.dataset.modalProduct || '';
      button.dataset.bundleRole = button.dataset.bundleRole || 'paid';
      button.classList.add('is-filled');
      button.setAttribute('aria-expanded', 'false');
      const imageMarkup = image ? `<img src="${escapeHtml(image)}" alt="">` : '<span class="bundle-add-row__placeholder">No image</span>';
      button.innerHTML = `<span class="bundle-add-row__selected">${imageMarkup}<span><b>${escapeHtml(title)}</b><small>${escapeHtml(variantTitle)}</small></span></span><span class="bundle-add-row__edit">Edit</span>`;
      refreshOfferTotals(currentVariant);
    };
    const openBundleModal = (button) => {
      if (!bundleModal?.showModal) return;
      activeBundleButton = button;
      const freeOnly = button.dataset.bundleRole === 'free';
      bundleModal.querySelectorAll('[data-modal-product]').forEach((card) => {
        card.hidden = freeOnly && card.dataset.modalFreeEligible !== 'true';
        if (card.hidden) return;
        const existing = modalVariants(card).find((variant) => String(variant.id) === String(button.dataset.variantId));
        if (existing) applyModalVariant(card, existing);
        else applyModalVariant(card, modalVariant(card));
      });
      bundleModal.showModal();
    };
    bundleClose?.addEventListener('click', () => bundleModal?.close());
    bundleModal?.addEventListener('click', (event) => { if (event.target === bundleModal) bundleModal.close(); });
    bundleModal?.querySelectorAll('[data-modal-product]').forEach((card) => {
      card.querySelectorAll('[data-modal-option-dropdown]').forEach((group) => {
        const trigger = group.querySelector('[data-modal-option-trigger]');
        const menu = group.querySelector('[data-modal-option-menu]');
        trigger?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); const open = menu?.hidden; modalCloseMenus(group); if (menu) menu.hidden = !open; trigger.setAttribute('aria-expanded', open ? 'true' : 'false'); });
        group.querySelectorAll('[data-modal-option-value]').forEach((option) => option.addEventListener('click', (event) => {
          event.preventDefault();
          setModalOption(card, group, option.dataset.modalOptionValue);
          if (menu) menu.hidden = true;
          trigger?.setAttribute('aria-expanded', 'false');
        }));
      });
      applyModalVariant(card, modalVariant(card));
      card.querySelector('[data-modal-choose]')?.addEventListener('click', () => {
        const variant = modalVariant(card);
        if (activeBundleButton && variant?.available) renderBundleSelection(activeBundleButton, card, variant);
        bundleModal.close();
      });
    });
    bundleModal?.addEventListener('click', (event) => { if (!event.target.closest('[data-modal-option-dropdown]')) modalCloseMenus(); });
    offerStack?.querySelectorAll('[data-offer]').forEach((offer) => offer.addEventListener('click', (event) => {
      if (event.target.closest('[data-bundle-plus]')) return;
      offerStack.querySelectorAll('[data-offer]').forEach((item) => { item.classList.toggle('is-selected', item === offer); item.querySelector('[data-offer-lines]')?.toggleAttribute('hidden', item !== offer); });
      if (quantityInput) quantityInput.value = offer.dataset.offerQuantity || '1';
      selectedOfferCode = offer.dataset.offerCode || '';
    }));
    form.querySelectorAll('[data-bundle-plus]').forEach((button) => button.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); openBundleModal(button); }));
    form.querySelectorAll('[data-current-option]').forEach((select) => select.addEventListener('change', () => {
      const group = optionGroups[Number(select.dataset.currentOption)];
      const input = group?.querySelector(`input[value="${CSS.escape(select.value)}"]`);
      if (input) { input.checked = true; input.dispatchEvent(new Event('change', {bubbles:true})); updateOptionTrigger(group, select.value); }
    }));
    form.querySelectorAll('[data-option-index] input').forEach((input) => input.addEventListener('change', sync));
    const buildOfferItems = () => {
      const quantity = Number(quantityInput?.value || 1);
      if (quantity === 1) return [{id:variantInput.value,quantity:1}];
      const selectedOffer = offerStack?.querySelector(`[data-offer-quantity="${quantity}"]`);
      const lines = Array.from(selectedOffer?.querySelectorAll('[data-bundle-plus].is-filled') || []).sort((a,b) => Number(a.dataset.bundleSlot) - Number(b.dataset.bundleSlot));
      if (lines.length !== quantity - 1) {
        window.alert(quantity === 4 ? 'Choose two more paid pieces and your free tee first.' : 'Choose the second piece first.');
        return null;
      }
      if (quantity === 4) {
        const freeLine = lines.find((line) => line.dataset.bundleRole === 'free');
        if (!freeLine || !flagshipHandles.has(freeLine.dataset.productHandle || '')) {
          window.alert('Your free item must be one of the four flagship tees.');
          return null;
        }
      }
      const setName = quantity === 4 ? 'BUY 3 GET 1' : 'SET 2';
      return [
        {id:variantInput.value,quantity:1,properties:{'_Bundle':setName,'_Bundle Role':'PAID'}},
        ...lines.map((line) => ({id:line.dataset.variantId,quantity:1,properties:{'_Bundle':setName,'_Bundle Role':line.dataset.bundleRole === 'free' ? 'FREE TEE' : 'PAID'}}))
      ];
    };
    form.addEventListener('submit', async (event) => {
      if (event.submitter !== addButton) return;
      event.preventDefault();
      if (!variantInput.value || addButton.disabled) return;
      const items = buildOfferItems();
      if (!items) return;
      addButton.disabled = true;
      try { await addItems(items); showToast(); if (selectedOfferCode) window.location.assign(endpoint('discount/' + encodeURIComponent(selectedOfferCode) + '?redirect=/cart')); }
      catch (_) { window.alert('Could not add this item. Please try again.'); }
      finally { sync(); }
    });
    buyButton?.addEventListener('click', async () => {
      if (!variantInput.value || buyButton.disabled) return;
      const items = buildOfferItems();
      if (!items) return;
      buyButton.disabled = true;
      try {
        await addItems(items);
        const checkoutPath = selectedOfferCode ? 'discount/' + encodeURIComponent(selectedOfferCode) + '?redirect=/checkout' : 'checkout';
        window.location.assign(endpoint(checkoutPath));
      } catch (_) {
        window.alert('Could not add this set. Please try again.');
        buyButton.disabled = false;
      }
    });
    sync();
  });

  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    const tabs = Array.from(builder.querySelectorAll('[data-bundle-count]'));
    const choices = Array.from(builder.querySelectorAll('[data-bundle-choice]'));
    const totalNode = builder.querySelector('[data-bundle-total]');
    const savingNode = builder.querySelector('[data-bundle-saving]');
    const addButton = builder.querySelector('[data-bundle-add]');
    let target = Number(builder.dataset.defaultBundleCount || 2);

    const selectedChoices = () => choices.filter((choice) => choice.querySelector('[data-bundle-check]')?.checked);
    const refresh = () => {
      choices.forEach((choice) => choice.classList.toggle('is-selected',choice.querySelector('[data-bundle-check]')?.checked));
      const selectedItems = selectedChoices();
      const subtotal = selectedItems.reduce((sum,choice) => sum + Number(choice.querySelector('[data-bundle-variant]')?.selectedOptions[0]?.dataset.price || 0),0);
      const saving = target === 4 ? Math.min(3500, Number(selectedItems.at(-1)?.querySelector('[data-bundle-variant]')?.selectedOptions[0]?.dataset.price || 0)) : Math.min(1000, subtotal);
      if (totalNode) totalNode.textContent = money(Math.max(0, subtotal - saving));
      if (savingNode) savingNode.textContent = selectedItems.length === target ? 'Save ' + money(saving) + ' at checkout' : 'Choose ' + target + ' items';
      if (addButton) addButton.disabled = selectedItems.length !== target;
    };

    tabs.forEach((tab) => tab.addEventListener('click', () => {
      target = Number(tab.dataset.bundleCount);
      tabs.forEach((item) => item.setAttribute('aria-pressed',item === tab ? 'true' : 'false'));
      const current = selectedChoices();
      if (current.length > target) current.slice(target).forEach((choice) => { choice.querySelector('[data-bundle-check]').checked = false; });
      if (current.length < target) choices.filter((choice) => !choice.querySelector('[data-bundle-check]').checked).slice(0,target-current.length).forEach((choice) => { choice.querySelector('[data-bundle-check]').checked = true; });
      refresh();
    }));

    choices.forEach((choice) => {
      choice.querySelector('[data-bundle-check]')?.addEventListener('change', (event) => {
        if (event.target.checked && selectedChoices().length > target) {
          event.target.checked = false;
        }
        refresh();
      });
      choice.querySelector('[data-bundle-variant]')?.addEventListener('change', refresh);
    });

    addButton?.addEventListener('click', async () => {
      const selectedItems = selectedChoices();
      if (selectedItems.length !== target) return;
      addButton.disabled = true;
      const setName = target === 4 ? 'BUY 3 GET 1' : 'SET 2';
      const items = selectedItems.map((choice, index) => ({id:choice.querySelector('[data-bundle-variant]').value,quantity:1,properties:{'_Bundle':setName,'_Bundle Role':target === 4 && index === selectedItems.length - 1 ? 'FREE TEE' : 'PAID'}}));
      try {
        await addItems(items);
        const code = target === 4 ? builder.dataset.discountFour : builder.dataset.discountTwo;
        window.location.assign(endpoint('discount/' + encodeURIComponent(code) + '?redirect=/cart'));
      } catch (_) {
        window.alert('Could not add this set. Please try again.');
        addButton.disabled = false;
      }
    });
    refresh();
  });

  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  menuButton?.addEventListener('click', () => {
    const open = menuButton.getAttribute('aria-expanded') === 'true';
    menuButton.setAttribute('aria-expanded',open ? 'false' : 'true');
    mobileNav.hidden = open;
  });
});
